import { axios } from '../helpers'
import apiError from '../helpers/apiError'

const personAuth = async ({ username, password }) => {
  console.log('CALL personAuth', username, password)
  const formData = new FormData()

  formData.append('username', username)
  formData.append('password', password)

  const res = await axios.request({
    url: 'person/auth',
    method: 'POST',
    data: formData
  })

  const { data } = res

  if (data && data.success) {
    return data.payload
  } else {
    await axios.changeURL()

    const res = await axios.request({
      url: 'person/auth',
      method: 'POST',
      data: formData
    })

    const { data } = res

    if (data && data.success) {
      return data.payload
    }
  }

  const errorData = (data && data.error) || { code: 999, msg: 'unknown' }

  throw new apiError('test', errorData)
}

export default personAuth

// import { axios, handleApiErrors } from '../helpers'

// export default ({ username, password }) => {
//   const data = new FormData()

//   data.append('username', username)
//   data.append('password', password)

//   return axios.request({
//     url: 'person/auth',
//     method: 'POST',
//     data
//   }).then(handleApiErrors)
// }
